import WindowResolver from './WindowResolver'


declare global {
  interface Window {
    CE2(method: string, ...args: any[]): void
  }
}

/*

  This crazyegg analytics

  Docs:
  https://help.crazyegg.com/article/99-user-variables

  From docs:

  window.CE2.set(userVar, value)

  Usage:

  ce2.set(userVar, value)

  userVar: A number from 1 to 5
  value: Any string value (it may be truncated if it is over 100 characters)

 */

const windowEntity = 'CE2'

const methods = {
  set: true,
}

interface ICE2 {
  set(userVar: 1 | 2 | 3 | 4 | 5, value: string): void
}

const ce2 = new WindowResolver({
  name: windowEntity,
  methods,
  resolver: () => Boolean(window.CE2),
  eventHandler: (methodName, userVar, value) => {
    window.CE2[methodName](userVar, value)
  },
}) as unknown as ICE2


export default ce2

export {
  windowEntity,
  methods,
}
